<template>
  <div>
    <ion-header>
      <ion-toolbar>
        <ion-title>Scan QR Code</ion-title>
        <ion-buttons slot="start">
          <ion-button @click="onClose">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <qrcode-stream @decode="onDecode"></qrcode-stream>
    </ion-content>
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import isUrl from "is-url";

export default {
  name: "QRCodeScannerModal",
  props: ["onCode"],
  components: {
    QrcodeStream
  },
  methods: {
    onDecode(value) {
      let code = value;
      if (isUrl(value)) {
        const segements = new URL(value).pathname.split("/");
        if (segements[1] === "asset") {
          code = segements[2];
        } else {
          code = undefined;
        }
      }
      if (typeof this.onCode === "function") {
        this.onCode(code);
      }
      this.onClose();
    },
    onClose() {
      this.$ionic.modalController.dismiss();
    }
  }
};
</script>
